var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBnLinkedIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b970968f-dd5e-418e-9f9f-1ea791223924",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .a9f8cb2d-13a1-4579-b980-0843656e42ca {\r\n        fill: #ccc;\r\n      }\r\n\r\n      .ad65a861-2cbc-4d2e-90ea-d401961e60ed {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "a9f8cb2d-13a1-4579-b980-0843656e42ca",
    width: 45,
    height: 45,
    rx: 7.101
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ad65a861-2cbc-4d2e-90ea-d401961e60ed",
    d: "M10.418,6.608a3.821,3.821,0,1,1-3.847,3.815A3.837,3.837,0,0,1,10.418,6.608Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad65a861-2cbc-4d2e-90ea-d401961e60ed",
    d: "M12.64,38.388H8.16a1.054,1.054,0,0,1-1.053-1.053V18.224A1.054,1.054,0,0,1,8.16,17.171h4.48a1.053,1.053,0,0,1,1.052,1.053V37.335A1.053,1.053,0,0,1,12.64,38.388Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad65a861-2cbc-4d2e-90ea-d401961e60ed",
    d: "M38.429,23.884a7.254,7.254,0,0,0-7.254-7.254H30.026A6.44,6.44,0,0,0,24.732,19.4a6.315,6.315,0,0,0-.352.567.492.492,0,0,0-.06-.008V17.608a.437.437,0,0,0-.437-.437H18.294a.437.437,0,0,0-.437.437V37.951a.437.437,0,0,0,.437.437H24a.437.437,0,0,0,.438-.437V26.2a3.724,3.724,0,0,1,3.651-3.741,3.693,3.693,0,0,1,3.737,3.694v11.8a.437.437,0,0,0,.437.437h5.725a.437.437,0,0,0,.437-.437V23.884Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnLinkedIn);
export default __webpack_public_path__ + "static/media/bnLinkedIn.9865406c985302c0fa8e1ce35e974f35.svg";
export { ForwardRef as ReactComponent };